import { render, staticRenderFns } from "./CompactNavTabs.vue?vue&type=template&id=28975018&scoped=true"
import script from "./CompactNavTabs.vue?vue&type=script&lang=js"
export * from "./CompactNavTabs.vue?vue&type=script&lang=js"
import style0 from "./CompactNavTabs.vue?vue&type=style&index=0&id=28975018&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28975018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28975018')) {
      api.createRecord('28975018', component.options)
    } else {
      api.reload('28975018', component.options)
    }
    module.hot.accept("./CompactNavTabs.vue?vue&type=template&id=28975018&scoped=true", function () {
      api.rerender('28975018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/CompactNavTabs.vue"
export default component.exports